import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert.jsx";
import MyPage from "../../MyPage.js";
import SubTabsDashboard from "../../SubTabsDashboard.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class DashboardStock extends Component{ 

    constructor(props){
      super(props);

      this.state={
          stockcover:[],
          modalTitle:"",
          stockcoverid:0,
          fyname_ist:"",
          regionname_ist:"",
          warehousename_ist:"",
          itemtypename_ist:"",
          july_ist:"",
          august_ist:"",
          september_ist:"",
          october_ist: "",
          november_ist: "",
          december_ist: "",
          january_ist: "",
          february_ist: "",
          march_ist: "",
          april_ist: "",
          may_ist: "",
          june_ist:"",

          RegionNameFilter:"",
          WarehouseNameFilter:"",
          FiscalYearFilter:"",
          InboundIdFilter:"",
          ItemTypeFilter:"",
          CurrentYearFilter:"",
          stockcoverWithoutFilter:[],
          loading: true,
          currentYearIndex: 0,
          currentYear: null,
      }
  }

  FilterFn(){
    var RegionNameFilter = this.state.RegionNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var InboundIdFilter = this.state.InboundIdFilter;
    var CurrentYearFilter = this.state.CurrentYearFilter;
    var ItemTypeFilter = this.state.ItemTypeFilter;

    var filteredData=this.state.stockcoverWithoutFilter.filter(
        function(el){
            return el.regionname_ist.toString().toLowerCase().includes(
                RegionNameFilter.toString().trim().toLowerCase()
            )&&  
                el.warehousename_ist.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                el.fyname_ist.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
            el.stockcoverid.toString().toLowerCase().includes(
            InboundIdFilter.toString().trim().toLowerCase()
        )&&  
        el.itemtypename_ist.toString().toLowerCase().includes(
        ItemTypeFilter.toString().trim().toLowerCase()
    )
        }
    );

    this.setState({stockcover:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.stockcoverWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({stockcover:sortedData});

}


changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}

changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }

changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }



changeInboundIdFilter = (e)=>{
    this.state.InboundIdFilter=e.target.value;
    this.FilterFn();
  }

  changeItemTypeFilter = (e)=>{
    this.state.ItemTypeFilter=e.target.value;
    this.FilterFn();
  }

  changeCurrentYearFilter = (e)=>{
    this.state.CurrentYearFilter=e.target.value;
    this.FilterFn();
  }



refreshList = () => {
    axiosService.get('/stockcover/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ stockcover: data, stockcoverWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };



componentDidMount(){
  this.refreshList();
}



render(){
  const {
      stockcover,
      modalTitle,
      stockcoverid,
      warehousename_ist,
      regionname_ist,
      fyname_ist,
      july_ist,
      august_ist,
      september_ist,
      october_ist,
      november_ist,
      december_ist,
      january_ist,
      february_ist,
      march_ist,
      april_ist,
      may_ist,
      june_ist,
      loading,
      fiscalYears,
      currentYearIndex,
      currentYear

  }=this.state;

  //const currentYear = fiscalYears[currentYearIndex];

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsDashboard />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      value={currentYear}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameFilter}
      placeholder="Filter"/>
      </div>
      Region
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItemTypeFilter}
      placeholder="Filter"/>
      </div>
      ItemType
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {stockcover.map(dep=>
      <tr key={dep.stockcoverid} className="row-hover">
          <td className="table-text">{dep.fyname_ist ?? 'N/A'}</td>
          <td className="table-text">{dep.regionname_ist ?? 'N/A'}</td>
          <td className="table-text">{dep.warehousename_ist ?? 'N/A'}</td>
          <td className="table-text">{dep.itemtypename_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.july_ist) < 6 ? 'text-danger' : ''}`}>{dep.july_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.august_ist) < 6 ? 'text-danger' : ''}`}>{dep.august_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.september_ist) < 6 ? 'text-danger' : ''}`}>{dep.september_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.october_ist) < 6 ? 'text-danger' : ''}`}>{dep.october_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.november_ist) < 6 ? 'text-danger' : ''}`}>{dep.november_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.december_ist) < 6 ? 'text-danger' : ''}`}>{dep.december_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.january_ist) < 6 ? 'text-danger' : ''}`}>{dep.january_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.february_ist) < 6 ? 'text-danger' : ''}`}>{dep.february_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.march_ist) < 6 ? 'text-danger' : ''}`}>{dep.march_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.april_ist) < 6 ? 'text-danger' : ''}`}>{dep.april_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.may_ist) < 6 ? 'text-danger' : ''}`}>{dep.may_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.june_ist) < 6 ? 'text-danger' : ''}`}>{dep.june_ist ?? 'N/A'}</td>
          <td>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>
</div>
  )
}
  }




